import * as React from 'react'

import { SMALL_ICON_BASE_SRC } from '../../../Shared/utils/constants'

const reviewCorrectSrc = `${SMALL_ICON_BASE_SRC}/review-correct.svg`

// The visible label reads "Target Skill Met" in both states -- the tick and the colour carry the
// difference, and neither reaches assistive tech -- so the visual half is hidden and the state said.
const SkillCheck = ({ met, }: { met: boolean }) => (
  <div className={`skill-check ${met ? 'met' : ''}`}>
    <span aria-hidden="true" className="skill-check-circle">
      {met && <img alt="" src={reviewCorrectSrc} />}
    </span>
    <span aria-hidden="true" className="skill-check-label">Target Skill Met</span>
    <span className="sr-only">{met ? 'Target skill met' : 'Target skill not met yet'}</span>
  </div>
)

export default SkillCheck
